import { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Icon } from '@chakra-ui/react';
import { MdOutlineList, MdChevronRight } from 'react-icons/md';
import { IconType } from 'react-icons/lib';
import { SideSubMenuItem } from '../SideSubMenuItem';
import { Wrapper } from '../SideSubMenu/styles';
import { Chevron, GroupHeader, GroupTitle } from './styles';

interface ChildItem {
  title: string;
  to: string;
  icon?: IconType;
}

interface Props {
  title: string;
  icon?: IconType;
  childrens: ChildItem[];
}

export function SideSubMenuGroup({ title, icon = MdOutlineList, childrens }: Props) {
  const { pathname } = useLocation();
  const hasActiveChild = childrens.some((child) => pathname.includes(child.to));
  const [isOpen, setIsOpen] = useState(hasActiveChild);

  return (
    <div>
      <GroupHeader onClick={() => setIsOpen((prev) => !prev)}>
        <GroupTitle>
          <Icon as={icon} fontSize={'lg'} mr={2} />
          <p style={{ fontSize: '12px' }}>{title}</p>
        </GroupTitle>
        <Chevron open={isOpen}>
          <Icon as={MdChevronRight} fontSize={'md'} />
        </Chevron>
      </GroupHeader>

      <Wrapper style={{ margin: '0 0 0 20px' }} className={isOpen ? 'open' : ''}>
        {childrens.map((child, index) => (
          <SideSubMenuItem key={index} {...child} />
        ))}
      </Wrapper>
    </div>
  );
}
